__webpack_require__.p = "https://assets-01.periodica.press/d96255e-21204002635/";